// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader {
  margin: 20% auto;
  text-align: center;
  }
  .loader-container{
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0px;
    text-align: center;
    bottom: 0px;
    right: 0px;
    left: 0px;
    background: #ffffff;
    z-index: 9999999999999;
  }
  /* .loader:before {
    animation: left-to-right 3s alternate infinite linear;
    background-image: linear-gradient(to right, transparent, red, transparent);
    content: "";
    height: 5vh;
  
    left: 50%;
    overflow: hidden;
    position: absolute;
    right: 0;
    width: 200px;
    top: 50%;
  }
  .loader:after {
    background-image: repeating-linear-gradient(90deg, white, white 1vw, transparent 1vw, transparent 10vw);
    content: "";
    height: 5vh;
    
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 80%;
  } */
  
  @keyframes left-to-right {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(100%);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/loader/loader.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,SAAS;IACT,mBAAmB;IACnB,sBAAsB;EACxB;EACA;;;;;;;;;;;;;;;;;;;;;;KAsBG;;EAEH;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,2BAA2B;IAC7B;EACF","sourcesContent":[".loader {\n  margin: 20% auto;\n  text-align: center;\n  }\n  .loader-container{\n    width: 100%;\n    height: 100%;\n    position: fixed;\n    top: 0px;\n    text-align: center;\n    bottom: 0px;\n    right: 0px;\n    left: 0px;\n    background: #ffffff;\n    z-index: 9999999999999;\n  }\n  /* .loader:before {\n    animation: left-to-right 3s alternate infinite linear;\n    background-image: linear-gradient(to right, transparent, red, transparent);\n    content: \"\";\n    height: 5vh;\n  \n    left: 50%;\n    overflow: hidden;\n    position: absolute;\n    right: 0;\n    width: 200px;\n    top: 50%;\n  }\n  .loader:after {\n    background-image: repeating-linear-gradient(90deg, white, white 1vw, transparent 1vw, transparent 10vw);\n    content: \"\";\n    height: 5vh;\n    \n    overflow: hidden;\n    position: absolute;\n    right: 0;\n    top: 80%;\n  } */\n  \n  @keyframes left-to-right {\n    0% {\n      transform: translateX(-100%);\n    }\n    100% {\n      transform: translateX(100%);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
